export default "__VITE_ASSET__qD4LLotR__"